import PocketBase from "pocketbase";

function currentOrigin(): string {
  if (typeof window === "undefined") return "http://127.0.0.1:8090";
  return window.location.origin;
}

export const pocketBaseUrl = (import.meta.env.VITE_POCKETBASE_URL || currentOrigin()).replace(/\/$/, "");
export const apiBaseUrl = (import.meta.env.VITE_API_URL || import.meta.env.VITE_APP_API_URL || pocketBaseUrl).replace(/\/$/, "");
export const tusEndpoint = import.meta.env.VITE_TUS_ENDPOINT || "/uploads/";

export const pb = new PocketBase(pocketBaseUrl);

// Requests are keyed and cancelled explicitly through TanStack Query instead.
pb.autoCancellation(false);

export function bearerHeaders(): HeadersInit {
  return pb.authStore.token ? { Authorization: `Bearer ${pb.authStore.token}` } : {};
}
